import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';

export default {
    name : 'swiper-products',

    init()
    {
        const items = document.querySelectorAll('.swiper--products');
        if (items.length) {
            setTimeout(this.run, 100);
        }
    },
    run ()
    {
        const collections = document.querySelectorAll('.swiper--products');

        if (!collections) {
            return false;
        }

        const sliderIds = [];
        collections.forEach((element) => sliderIds.push(element.id));

        const sliders = [];

        if (sliderIds.length) {
            for (let i=0; i<sliderIds.length;i++) {
                sliders[i] = new Swiper('#'+sliderIds[i] , {
                        navigation: {
                            nextEl: '#'+sliderIds[i]+ " .swiper-button-next",
                            prevEl: '#'+sliderIds[i] + " .swiper-button-prev",
                        },

                        scrollbar: {
                            el: '#'+sliderIds[i]+" .swiper-scrollbar",
                            hide: false,
                        },

                        spaceBetween: 10,

                        slidesPerView: 2,

                        breakpoints: {
                            768: {
                                freeMode: false,
                                slidesPerView: 3,
                            },

                            1200: {
                                centeredSlides: false,
                                slidesPerView: 4.5,
                            }
                        },
                    }
                );
            }
        }
    } // run

} // export